module.exports = __webpack_public_path__ + "static/screen-classic-laptop@2x-d045c6fc71a675d5be53aeefe9533b76.webp";